import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { getImageUrl } from '../utils/cdn';
import './Header.css';

const Header = ({ settings }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { getCartCount } = useCart();
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const cartCount = getCartCount();

  const logoUrl = settings?.site_logo || '/logo.png';

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            {logoUrl ? (
              <img 
                src={getImageUrl(logoUrl)} 
                alt={settings?.site_name || 'NieHairLabel'} 
              />
            ) : (
              <span className="logo-text">{settings?.site_name || 'NieHairLabel'}</span>
            )}
          </Link>

          <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/shop" onClick={() => setMenuOpen(false)}>Shop</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>
            {isAdmin() && (
              <Link to="/hair-wp" onClick={() => setMenuOpen(false)}>Admin</Link>
            )}
          </nav>

          <div className="header-actions">
            {user ? (
              <>
                <Link to="/cart" className="cart-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                  {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
                </Link>
                {isAdmin() && (
                  <Link to="/hair-wp" className="btn-link">Admin</Link>
                )}
                <button onClick={logout} className="btn-link">Logout</button>
              </>
            ) : (
              <>
                <Link to="/cart" className="cart-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                  {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
                </Link>
                {/* Login link removed for security - access via direct URL only */}
              </>
            )}
            <button 
              className="menu-toggle"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

